var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _vm._v("\n      Loading...\n    ")
          ])
        : _c("div", [
            _c("h2", { staticClass: "mb-4" }, [_vm._v("Bewerk tafelsessie")]),
            _vm._v(" "),
            _c(
              "form",
              { on: { submit: _vm.handleSubmit } },
              [
                _vm.error
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n          Helaas is er wat verkeerds gegaan, controleer en probeer opnieuw.\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.title.error,
                    type: "text",
                    label: "Titel",
                    name: "title",
                    count: true,
                    max: 60
                  },
                  model: {
                    value: _vm.title.value,
                    callback: function($$v) {
                      _vm.$set(_vm.title, "value", $$v)
                    },
                    expression: "title.value"
                  }
                }),
                _vm._v(" "),
                _c("select-field", {
                  attrs: {
                    error: _vm.type.error,
                    label: "Soort",
                    name: "type",
                    tooltip:
                      "Let op, je moet zelf in je agenda aangeven wanneer je deze open inschrijfsessie wilt aanbieden, in een apart tijdslot. Anders kunnen mensen zich niet op deze sessie inschrijven",
                    options: [
                      {
                        code: "individueel",
                        label: "Open inschrijving"
                      },
                      {
                        code: "groepssessie",
                        label: "Teamtraining"
                      }
                    ]
                  },
                  model: {
                    value: _vm.type.value,
                    callback: function($$v) {
                      _vm.$set(_vm.type, "value", $$v)
                    },
                    expression: "type.value"
                  }
                }),
                _vm._v(" "),
                _c("text-field", {
                  attrs: {
                    error: _vm.excerpt.error,
                    label: "Samenvatting",
                    name: "excerpt",
                    rows: "3",
                    count: true,
                    max: 150
                  },
                  model: {
                    value: _vm.excerpt.value,
                    callback: function($$v) {
                      _vm.$set(_vm.excerpt, "value", $$v)
                    },
                    expression: "excerpt.value"
                  }
                }),
                _vm._v(" "),
                _c("text-field", {
                  attrs: {
                    error: _vm.content.error,
                    label: "Beschrijving",
                    name: "description",
                    rows: "15",
                    count: true,
                    max: 2250
                  },
                  model: {
                    value: _vm.content.value,
                    callback: function($$v) {
                      _vm.$set(_vm.content, "value", $$v)
                    },
                    expression: "content.value"
                  }
                }),
                _vm._v(" "),
                _c("text-field", {
                  attrs: {
                    error: _vm.leerdoelen.error,
                    label: "Leerdoelen",
                    name: "leerdoelen",
                    rows: "6",
                    count: true,
                    max: 2250
                  },
                  model: {
                    value: _vm.leerdoelen.value,
                    callback: function($$v) {
                      _vm.$set(_vm.leerdoelen, "value", $$v)
                    },
                    expression: "leerdoelen.value"
                  }
                }),
                _vm._v(" "),
                _c("text-field", {
                  attrs: {
                    error: _vm.doelgroep.error,
                    label: "Doelgroep",
                    name: "doelgroep",
                    rows: "6",
                    count: true,
                    max: 2250
                  },
                  model: {
                    value: _vm.doelgroep.value,
                    callback: function($$v) {
                      _vm.$set(_vm.doelgroep, "value", $$v)
                    },
                    expression: "doelgroep.value"
                  }
                }),
                _vm._v(" "),
                _c("multi-checkbox-field", {
                  attrs: {
                    error: _vm.language.error,
                    label: "Talen",
                    name: "language",
                    options: _vm.option_language
                  },
                  model: {
                    value: _vm.language.value,
                    callback: function($$v) {
                      _vm.$set(_vm.language, "value", $$v)
                    },
                    expression: "language.value"
                  }
                }),
                _vm._v(" "),
                _c("select-field", {
                  attrs: {
                    error: _vm.topic.error,
                    label: "Vakgebied",
                    name: "topic",
                    options: _vm.option_topics
                  },
                  model: {
                    value: _vm.topic.value,
                    callback: function($$v) {
                      _vm.$set(_vm.topic, "value", $$v)
                    },
                    expression: "topic.value"
                  }
                }),
                _vm._v(" "),
                _c("select-field", {
                  attrs: {
                    error: _vm.expertises.error,
                    label: "Trefwoorden",
                    name: "expertises",
                    options: _vm.option_expertises,
                    multiple: true,
                    max: 5,
                    taggable: true
                  },
                  model: {
                    value: _vm.expertises.value,
                    callback: function($$v) {
                      _vm.$set(_vm.expertises, "value", $$v)
                    },
                    expression: "expertises.value"
                  }
                }),
                _vm._v(" "),
                _c("file-field", {
                  attrs: {
                    error: _vm.thumbnail.error,
                    label: "Header foto",
                    name: "thumbnail",
                    multiple: false
                  },
                  model: {
                    value: _vm.thumbnail.value,
                    callback: function($$v) {
                      _vm.$set(_vm.thumbnail, "value", $$v)
                    },
                    expression: "thumbnail.value"
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.youtube.error,
                    type: "text",
                    label: "YouTube video toevoegen",
                    name: "youtube",
                    placeholder: "Plaats hier een YouTube video ID"
                  },
                  model: {
                    value: _vm.youtube.value,
                    callback: function($$v) {
                      _vm.$set(_vm.youtube, "value", $$v)
                    },
                    expression: "youtube.value"
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.max_participants.error,
                    type: "number",
                    label: "Maximaal aantal deelnemers (Minimaal is 10)",
                    name: "max_participants",
                    min: "10"
                  },
                  model: {
                    value: _vm.max_participants.value,
                    callback: function($$v) {
                      _vm.$set(_vm.max_participants, "value", $$v)
                    },
                    expression: "max_participants.value"
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    error: _vm.price.error,
                    type: "number",
                    label: "Kosten tafelsessie",
                    name: "price"
                  },
                  model: {
                    value: _vm.price.value,
                    callback: function($$v) {
                      _vm.$set(_vm.price, "value", $$v)
                    },
                    expression: "price.value"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row row-buttons" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-lg",
                        attrs: { type: "submit" }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M1.95833 14.625H13.0417C13.4616 14.625 13.8643 14.4582 14.1613 14.1613C14.4582 13.8643 14.625 13.4616 14.625 13.0417V4.33333L10.6667 0.375H1.95833C1.53841 0.375 1.13568 0.541815 0.838748 0.838748C0.541815 1.13568 0.375 1.53841 0.375 1.95833V13.0417C0.375 13.4616 0.541815 13.8643 0.838748 14.1613C1.13568 14.4582 1.53841 14.625 1.95833 14.625ZM3.54167 1.95833H6.70833V3.54167H8.29167V1.95833H9.875V5.125H3.54167V1.95833ZM3.54167 8.29167H11.4583V13.0417H3.54167V8.29167Z"
                              }
                            })
                          ]
                        ),
                        _vm._v("\n              Opslaan\n            ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dark btn-lg",
                        attrs: { type: "button" },
                        on: { click: _vm.handleDelete }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z"
                              }
                            })
                          ]
                        ),
                        _vm._v("\n              Verwijderen\n            ")
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Sessies/EditSessie.vue?vue&type=template&id=126deb36&
// module id = 390
// module chunks = 0